export default "__VITE_ASSET__Bs5O2_wP__"